import {createFragmentContainer, graphql} from 'react-relay';

const MonthByMonthTotalsLoader = ({relay, viewer, children, ...props}) => {
	const formatData = () => {
		return [
			{
				currency: viewer.company.currency,
				aggregatedFinancialNumbers: {
					...viewer.company.aggregatedFinancialNumbers,
				},
				timeAggregatedFinancialNumbers: {
					...viewer.company.timeAggregatedFinancialNumbers,
				},
				expenseAggregatedFinancialNumbers: {
					...viewer.company.expenseAggregatedFinancialNumbers,
				},
			},
		];
	};
	return children({data: {rows: formatData()}, ...props});
};

export const monthByMonthTotalsLoaderQuery = graphql`
	query MonthByMonthTotalsLoader_Query(
		$startYear: Int!
		$startMonth: Int!
		$startDay: Int!
		$endYear: Int!
		$endMonth: Int!
		$endDay: Int!
		$searchQuery: TaskSearchQueryType!
		$timeSearchQuery: TaskSearchQueryType!
		$expenseSearchQuery: TaskSearchQueryType!
		$selectedSingleValue: FinancialAggregatedNumber!
	) {
		viewer {
			actualPersonId
			component(name: "project_portfolio_month_by_month_totals_loader")
			...MonthByMonthTotalsLoader_viewer
				@arguments(
					searchQuery: $searchQuery
					timeSearchQuery: $timeSearchQuery
					expenseSearchQuery: $expenseSearchQuery
					startYear: $startYear
					startMonth: $startMonth
					startDay: $startDay
					endYear: $endYear
					endMonth: $endMonth
					endDay: $endDay
					selectedSingleValue: $selectedSingleValue
				)
		}
	}
`;

export default createFragmentContainer(MonthByMonthTotalsLoader, {
	viewer: graphql`
		fragment MonthByMonthTotalsLoader_viewer on Viewer
		@argumentDefinitions(
			searchQuery: {type: "TaskSearchQueryType!"}
			timeSearchQuery: {type: "TaskSearchQueryType!"}
			expenseSearchQuery: {type: "TaskSearchQueryType!"}
			startYear: {type: "Int!"}
			startMonth: {type: "Int!"}
			startDay: {type: "Int!"}
			endYear: {type: "Int!"}
			endMonth: {type: "Int!"}
			endDay: {type: "Int!"}
			selectedSingleValue: {type: "FinancialAggregatedNumber!"}
		) {
			id
			company {
				currency
				aggregatedFinancialNumbers(
					searchQuery: $searchQuery
					startYear: $startYear
					startMonth: $startMonth
					startDay: $startDay
					endYear: $endYear
					endMonth: $endMonth
					endDay: $endDay
					aggregateLevel: MONTH
					aggregates: [$selectedSingleValue]
				)
				timeAggregatedFinancialNumbers: aggregatedFinancialNumbers(
					searchQuery: $timeSearchQuery
					startYear: $startYear
					startMonth: $startMonth
					startDay: $startDay
					endYear: $endYear
					endMonth: $endMonth
					endDay: $endDay
					aggregateLevel: MONTH
					aggregates: [$selectedSingleValue]
				)
				expenseAggregatedFinancialNumbers: aggregatedFinancialNumbers(
					searchQuery: $expenseSearchQuery
					startYear: $startYear
					startMonth: $startMonth
					startDay: $startDay
					endYear: $endYear
					endMonth: $endMonth
					endDay: $endDay
					aggregateLevel: MONTH
					aggregates: [$selectedSingleValue]
				)
			}
		}
	`,
});
